import ActionResults from "./ActionResults";

export default class ActionValidator {
  constructor(action, state) {
    this.action = action;
    this.errorMessage = "";
    this.successMessage = "";
    this.history = state.actions.history;
    this.actionResults = new ActionResults(action, state);
  }

  _interrupt(action, until) {
    const conditionI = this.history.findIndex(each => each.id === until) < 0;
    return this.action.id === action && conditionI;
  }

  pass() {
    // here we define some rules
    if (
      this._interrupt('C1', 'I1') ||
      this._interrupt('T1', 'I1')
    ) {
      this.errorMessage = ("Before taking this action, you should gather additional information about the audiences to which you are communicating. Try something else for now.");
      return false;
    }
    this.successMessage = this.actionResults.getMessage();
    return true;
  }

  getErrorMessage() {
    return this.errorMessage;
  }

  getSuccessMessage() {
    return this.successMessage;
  }
}
